import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ServiceAreasList } from "@/features/admin/service-areas/list";
import {
  filterSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  search: z.string().optional(),
  inServiceArea: z.string().optional(),
  // state/city are single-select; "" is the empty-shell (chip added, no value).
  filters: z
    .object({
      state: withOperators(z.string().optional()),
      city: withOperators(z.string().optional()),
    })
    .optional(),
  sort: z.string().optional(),
  ...filterSearchFragment,
  ...maskSearchFragment,
});

export const Route = createFileRoute("/admin/service-areas")({
  validateSearch: searchSchema,
  component: ServiceAreasList,
});
